<script>
export default {
    props: ['map', 'data'],
    name: "cityMap",
    data() {
        return {
            options: {
                bounds: true,
                boundsPadding: 1,
                minZoom: 1,
                maxZoom: 2,
                initialZoom: 1,
                // transformOrigin: {x: 0.5, y: 0.5}
            },
            mapSize: null,
            touchActiveIndex: null,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() { 
        this.resize();
        window.addEventListener('resize', this.resize);
    },
     destroyed() {},
    watch: {},
    methods: {
        resize() { 
            this.mapSize = this.$refs.map.getBoundingClientRect();
        },
        scale(size) { 
            this.$refs.panZoom.$panZoomInstance.smoothZoom(this.mapSize.width / 2, this.mapSize.height / 2, size);
        },
        touchstart(index) { 
            this.touchActiveIndex = index;
        },
    },
};
</script>

<template>
    <div class="map" ref="map">
        <panZoom :options="options" ref="panZoom">
            <div class="wrap">
                <img class="bg" :src="map" alt=""/>
                <div class="list">
                    <template v-for="(item, index) in data">
                        <!-- <a class="item" v-if="item.link" :href="item.link" target="_blank" :style="`top: ${item.y}%; left: ${item.x}%; width: ${item.image1_width / 12}%;`">
                            <img :src="item.image1" alt="" class="icon"/>
                            <img :src="item.image2" alt="" class="icon_checked"/>
                        </a> -->
                        <div class="item" :class="{hover: touchActiveIndex == index}" @touchstart="touchstart(index)" :style="`top: ${item.y}%; left: ${item.x}%; width: ${item.image1_width / 12}%;`">
                            <img :src="item.image1" alt="" class="icon"/>
                            <img :src="item.image2" alt="" class="icon_checked"/>
                        </div>
                    </template>
                </div>
            </div>
        </panZoom>
        <div class="btn_scale_group">
            <div class="btn" @click="scale(0.5)"></div>
            <div class="btn" @click="scale(2)"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.map{
    position: relative;
    width: 100%;
    height: 8.1rem;
    overflow: hidden;
    @media only screen and (max-width: 750px) {
        height: 4.66rem;
    }
    .wrap{
        position: relative;
        width: 100%;
        height: 8.1rem;
        @media only screen and (max-width: 750px) {
            height: 4.66rem;
        }
    }
    .btn_scale_group{
        width: .64rem;
        height: .22rem;
        background: url('~@/assets/images/map_scale_btn_group.png') no-repeat 0/100%;
        position: absolute;
        right: .3rem;
        bottom: .3rem;
        z-index: 1;
        display: flex;
        .btn{
            flex: 1;
            cursor: pointer;
        }
        @media only screen and (max-width: 750px) {
            width: 1.28rem;
            height: .44rem;
        }
    }
    .bg{
        width: 100%;
    }
    .list{
        .item{
            position: absolute;
            img{
                width: 100%;
            }
            &.hover,
            &:hover{
                .icon{
                    display: none;
                }
                .icon_checked{
                    display: block;
                }
            }
            .icon_checked{
                display: none;
            }
            // @media only screen and (max-width: 750px) {
            //     .icon{
            //         display: none;
            //     }
            //     .icon_checked{
            //         display: block;
            //     }
            // }
        }
    }
}
</style>